import { lazy } from 'react';

import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';

const PinInputForm = lazy(() => import('./components/PinInputForm'));

export default function SetPinModal({ handleClose }) {
  return (
    <FormModal handleClose={handleClose}>
      <PinInputForm handleClose={handleClose} />
    </FormModal>
  );
}

SetPinModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
